// extracted by mini-css-extract-plugin
export default {"content":"delete-template_content__8Fsz7","tip":"delete-template_tip__oe4nC","text-bold":"delete-template_text-bold__y9RC1"};